// Core
import { all } from 'redux-saga/effects';

// Instruments
import { geoWatchers as geo } from 'bus/geo/saga/watchers';
import { queriesWatchers as queries } from 'bus/queries/saga/watchers';
import { searchWatchers as search } from 'bus/search/saga/watchers';
import { hotelsWatchers as hotels } from 'bus/hotels/saga/watchers';
import { offersWatchers as offers } from 'bus/offers/saga/watchers';
import { servicesWatchers as services } from 'bus/services/saga/watchers';
import { orderWatchers as order } from 'bus/order/saga/watchers';
import { reviewsWatchers as reviews } from 'bus/reviews/saga/watchers';
import { historyWatchers as history } from 'bus/history/saga/watchers';
import { compareWatchers as compare } from 'bus/compare/saga/watchers';
import { hotWatchers as hot } from 'bus/hot/saga/watchers';

export function* rootSaga () {
    yield all([
        geo.getSuggestsWatcher(),
        geo.getCountriesWatcher(),
        geo.getCitiesWatcher(),
        geo.getHotelsWatcher(),
        queries.parseQueryStringWatcher(),
        search.runSearchWatcher(),
        search.submitSearchWatcher(),
        search.getPriceChartWatcher(),
        hotels.getHotelWatcher(),
        services.getServicesWatcher(),
        offers.getOfferWatcher(),
        order.sendOrderWatcher(),
        reviews.getTurpravdaReviewsWatcher(),
        history.loadViewedHotelsWatcher(),
        history.addViewedHotelWatcher(),
        history.removeViewedHotelWatcher(),
        compare.addToCompareWatcher(),
        compare.removeFromCompareWatcher(),
        compare.loadLocalComparedWatcher(),
        hot.getBlockWatcher(),
        hot.getTourWatcher(),
        hot.getToursCountriesWatcher(),
        hot.getCountryRecommendedToursWatcher()
    ]);
}
